// Campus photo for /colleges/university-of-wisconsin-madison: CC BY-SA 2.0, by w_lemay, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3ABascom_Hall%2C_University_of_Wisconsin%2C_Bascom_Mall%2C_Madison%2C_WI.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/university-of-wisconsin-madison/; credited under the photo.
const photo = {
    "slug": "university-of-wisconsin-madison",
    "alt": "Bascom Hall at the top of Bascom Hill, with the Abraham Lincoln statue in front, at the University of Wisconsin-Madison",
    "src": "/colleges/university-of-wisconsin-madison/campus-1600.webp",
    "srcSmall": "/colleges/university-of-wisconsin-madison/campus-800.webp",
    "srcMid": "/colleges/university-of-wisconsin-madison/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/university-of-wisconsin-madison/og.jpg",
    "title": "Bascom Hall, University of Wisconsin, Bascom Mall, Madison, WI",
    "author": "w_lemay",
    "license": "CC BY-SA 2.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/2.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3ABascom_Hall%2C_University_of_Wisconsin%2C_Bascom_Mall%2C_Madison%2C_WI.jpg",
    "read": "2026-10-01"
};

export default photo;
